module.exports = __webpack_public_path__ + "SamsungOne-400C.f525bf001001bd7e6e15.ttf";


//////////////////
// WEBPACK FOOTER
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/assets/layout/fonts/SamsungOne-400C.ttf
// module id = ../../../../../src/assets/layout/fonts/SamsungOne-400C.ttf
// module chunks = styles